import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect} from 'react';
import {ScrollView, View} from 'react-native';
import {connect} from 'react-redux';
import {ApiResponse} from '../../../../data/types/interface/api';
import {StackParams} from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {Container} from '../../../components/Container';
import Select from '../../../components/Inputs/Select';
import {Loader} from '../../../components/Loader';

import {CONTRAT_LABELS} from '../../../../data/constants/Contrats/contrat';
import {
  IDataWS,
  ITypeAssurance,
} from '../../../../data/types/interface/infoAssurance';
import {AssuranceInfo} from '../../../components/Assurance/Info';
import AgeTab from '../../../components/Assurance/Scolaire/AgeTab';
import PrimaryButton from '../../../components/Button/PrimaryButton';
import {buttonsStyles} from '../../../components/Button/boutonStyle';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {formsStyles} from '../../../components/Inputs/formStyles';
import Label from '../../../components/Label';

type NavigationProps = StackNavigationProp<StackParams, 'AssuranceScolaire'>;

const defaultValue = {
  DateNaissaince: '- 12 ans',
  Selected: '',
};
interface dataOption {
  [label: string]: string;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function AssuranceGeneraleScreen(props: any) {
  const categorieAssuranceId = props?.route?.params?.id;
  const headerTitle = props?.route?.params?.headerTitle;
  const {getDetailTypeassurance, getTypeassurance, user} = props;
  const typeAssuranceId = props?.route?.params.typeId;

  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [active, setActive] = React.useState('-12');
  const [title, setTitle] = React.useState('Date de naissance: "-12 ans"');
  const [data, setData] = React.useState<Array<IDataWS>>();
  const [isScolaire, setIsScolaire] = React.useState(true);
  const [idAssurance, setIdAssurance] = React.useState('');
  const [IsLoading, setIsLoading] = React.useState(true);
  const [IsGlobalLoading, setIsGlobalLoading] = React.useState(true);
  const [montant, setMontant] = React.useState('');
  const [listTypeAssurance, setListTypeAssurnce] = React.useState<dataOption[]>(
    [],
  );
  const [typeAssurance, setTypeAssurance] = React.useState<string>('');

  const callback = (data: string) => {
    setActive(data);
    getAssurance(typeAssurance, data);

    setTitle(`Date de naissance: "${data} ans"`);
  };

  const handleTypeAssurance = (data: string) => {
    setIdAssurance(data);
    setIsScolaireAssurance(data);
  };

  const setIsScolaireAssurance = (data: React.SetStateAction<string>) => {
    setIsScolaire(isScolaire => !isScolaire);
    setTypeAssurance(data);
  };

  const selectFactory = (datas: ITypeAssurance[]) => {
    const selectData: dataOption[] = [];
    datas &&
      datas.forEach((data: ITypeAssurance) => {
        const elt: dataOption = {value: data.id, label: data.nom};
        selectData.push(elt);
      });
    return selectData;
  };

  const getAssurance = (idAssurance: string, sousType: string) => {
    setIsLoading(true);
    getTypeassurance(
      {},
      (res: ApiResponse) => {
        const result = selectFactory(res && res.data && [...res.data.items]);

        idAssurance === '' && setTypeAssurance(typeAssuranceId);
        const isNotRCVP = headerTitle.includes('Scolaire');
        setIsScolaire(isNotRCVP);

        const url = isNotRCVP
          ? `?typeId=${typeAssuranceId}&sousType=${sousType}&montant=false`
          : `?typeId=${typeAssuranceId}&montant=false`;
        const urlForMontant = isNotRCVP
          ? `?typeId=${typeAssuranceId}&sousType=${sousType}&montant=true`
          : `?typeId=${typeAssuranceId}&montant=true`;

        getDetailTypeassurance(
          {},
          (res: ApiResponse) => {
            setData(res && res.data && res.data.items);
            setIsLoading(false);
            setIsGlobalLoading(false);
          },
          url,
        );
        getDetailTypeassurance(
          {},
          (res: ApiResponse) => {
            setMontant(res.data);
          },
          urlForMontant,
        );

        setListTypeAssurnce(result);
      },
      `?categorieId=${categorieAssuranceId}`,
    );
  };

  const handleSubmit = () => {
    console.log(listTypeAssurance);
    const labelAssurance =
      listTypeAssurance &&
      listTypeAssurance.filter(
        assurance => assurance.value === typeAssurance,
      )[0].label;

    console.log(labelAssurance);

    switch (labelAssurance.toLowerCase()) {
      case CONTRAT_LABELS.scolaire.toLowerCase():
        user && user.data && user.data.utilisateur
          ? navigate('SouscriptionAssuranceScolaireForm', {
              typeAssurance: labelAssurance,
              montant: montant,
              age: active,
              typeId: typeAssuranceId,
            })
          : navigate('Login', {
              data: 'SouscriptionAssuranceScolaireForm',
              typeAssurance: labelAssurance,
              montant: montant,
              age: active,
              isSimulation: true,
              typeId: typeAssuranceId,
            });

        break;
      case CONTRAT_LABELS.rcvp.toLowerCase():
        user && user.data && user.data.utilisateur
          ? navigate('SouscriptionAssuranceRCVPForm', {
              typeAssurance: labelAssurance,
              montant: montant,
              typeId: typeAssuranceId,
            })
          : navigate('Login', {
              data: 'SouscriptionAssuranceRCVPForm',
              typeAssurance: labelAssurance,
              montant: montant,
              isSimulation: true,
              typeId: typeAssuranceId,
            });

        break;
      default:
        break;
    }
  };

  useEffect(() => {
    getAssurance(idAssurance, active);
  }, [idAssurance]);

  return (
    <Container>
      <View>
        <HeaderScreen type="retour" title={headerTitle} noBreadcrumb={false} />
        <ScrollView>
          {IsGlobalLoading ? (
            <Loader />
          ) : (
            <View style={formsStyles.webformContain}>
              <View style={formsStyles.formContain}>
                <View>
                  <Label title={headerTitle} type="mainTitle" />
                  <Select
                    style={{display: 'none'}}
                    data={listTypeAssurance}
                    label="Choisir type assurance"
                    value={defaultValue.Selected}
                    required={true}
                    onChange={(name: string, data: string) =>
                      handleTypeAssurance(data)
                    }
                    disabled
                  />
                  {isScolaire && (
                    <View>
                      <AgeTab active={active} callBack={callback} />
                    </View>
                  )}
                  {IsLoading ? (
                    <Loader />
                  ) : (
                    <ScrollView>
                      {isScolaire && (
                        <Label
                          title={
                            title && title.includes('-')
                              ? title
                              : title.replace('12', '+12')
                          }
                        />
                      )}
                      <AssuranceInfo
                        isVisible={true}
                        title={title}
                        data={data}
                      />
                    </ScrollView>
                  )}
                </View>
                <View style={[buttonsStyles.displayCenter, {marginBottom: 60}]}>
                  <View style={buttonsStyles.displayHorizontal}>
                    <PrimaryButton
                      onPress={() => goBack()}
                      styleBtnTxt={buttonsStyles.btnAnnuler}
                      styleBtnOuter={buttonsStyles.btnAnnulerOuterSimu}
                      title="Annuler"
                      type="annuler"
                    />
                    <PrimaryButton
                      onPress={handleSubmit}
                      styleBtnTxt={buttonsStyles.btnValider}
                      styleBtnOuter={buttonsStyles.btnValiderOuterSimu}
                      title="Souscrire"
                      type="valider"
                    />
                  </View>
                </View>
              </View>
            </View>
          )}
        </ScrollView>
      </View>
    </Container>
  );
}

export const AssuranceGenerale = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssuranceGeneraleScreen);
